import email from '../../assets/images/email.svg'
import password from '../../assets/images/password.svg'
const listInput  = [
    {
        label : email,
        name : 'email',
        placeholder : 'Email',
        type : 'text',
        require: true,
        errorMsg: "Email không hợp lệ",
        requireMsg: "Vui lòng nhập email",
        match: '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$',
    },
    {
        label : password,
        name : 'password',
        placeholder : 'Mật khẩu',
        require: true,
        type : 'password',
        requireMsg: "Vui lòng nhập mật khẩu",
        errorMsg: "Mật khẩu chỉ cho phép nhập từ 8-50 ký tự",
        match: '^.{8,50}$',
    }
]
export default listInput